import React from 'react';
import { useMessageSource } from 'react-message-source';
import type { FeatureFlag } from '../types';

export type FeatureFlagToggleProps = {
  flag: FeatureFlag;
  disabled?: boolean;
  isSaving?: boolean;
  onToggle: (flagKey: string, enabled: boolean) => void;
};

const sourceKeyMap: Record<string, string> = {
  unlock: 'featureFlag.source.unlock',
  plugin: 'featureFlag.source.plugins',
  local: 'featureFlag.source.local',
  appsettings: 'featureFlag.source.appsettings',
  default: 'featureFlag.source.default',
  unregistered: 'featureFlag.source.unregistered',
};

const FeatureFlagToggle = ({ flag, disabled, isSaving, onToggle }: FeatureFlagToggleProps) => {
  const { getMessage } = useMessageSource();
  const label = getMessage(flag.label) || flag.label || flag.key;
  const sourceMessage = sourceKeyMap[flag.source]
    ? getMessage(sourceKeyMap[flag.source])
    : flag.source;

  const descriptionId = `${flag.key}-description`;
  const isDisabled = disabled || isSaving;

  return (
    <div className="feature-flag-toggle">
      <div className="feature-flag-toggle__label">
        <span className="feature-flag-toggle__title">{label}</span>
        <span className="feature-flag-toggle__source" id={descriptionId}>
          {sourceMessage}
        </span>
      </div>
      <label
        className={`feature-flag-toggle__switch ${isSaving ? 'feature-flag-toggle__switch--saving' : ''}`}
        aria-label={`${label}を切り替え`}
      >
        <input
          type="checkbox"
          checked={flag.enabled}
          disabled={isDisabled}
          onChange={(event) => onToggle(flag.key, event.target.checked)}
          aria-describedby={descriptionId}
        />
        <span className="feature-flag-toggle__slider" />
        {isSaving && (
          <span className="feature-flag-toggle__saving-indicator" aria-hidden="true" />
        )}
      </label>
    </div>
  );
};

export default FeatureFlagToggle;
